<template>
  <section class="container pb-5">
    <section class="row mb-2 mb-md-5">
      <div class="col-12">
        <h1 class="text-center">
          Vos parrainages
        </h1>
      </div>
    </section>
    <div class="row mb-4">
      <div class="col-12">
        <h2 class="text-blue-700 ">
          Comment fonctionne les parrainages
        </h2>
        <p>
          <span>{{ clientCount }} clients ASSURUP</span> ont déjà parrainé leurs amis et leurs proches. <br>
          Pourquoi pas vous ? Invitez votre entourage et profitez, vous aussi, de votre cagnotte !
        </p>
        <router-link
          to="/client/perks/sponsorship"
        >
          Invitez vos amis maintenant
        </router-link>
      </div>
    </div>

    <!-- 3 étapes -->
    <div class="row mb-5">
      <div
        v-for="(step, index) in steps"
        :key="step.title"
        class="col-12 col-md-4 mb-3"
      >
        <div
          class="card text-center shadow cursor-pointer"
          style="min-height:264px"
        >
          <div
            class="card-body d-flex flex-column transition-shadow
              justify-content-around rounded-4"
            :class="`box-shadow-${step.color} box-shadow-hover-${step.color}`"
          >
            <span
              v-for="i in 3"
              :key="i"
              class="pills-image"
              :class="[ `pill-card-${index + 1}-${i}` ]"
            />
            <h5 class="d-flex mx-auto">
              {{ step.title }}
            </h5>
            <div class="d-flex mx-auto">
              <v-icon
                :icon="step.icon"
                folder="dashboard/svg/sponsorship"
                :height="80"
                :width="80"
              />
            </div>
            <p class="mb-0 ">
              {{ step.description }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ -->
    <div class="row">
      <div class="col-12">
        <div class="card shadow-sm">
          <div
            class="card-body rounded-4 transition-shadow p-4
            box-shadow-pink-300 box-shadow-hover-pink-300"
          >
            <h3 class="mb-4">
              <font-awesome-icon
                icon="question-circle"
                class="me-2 text-blue-700"
              />
              Questions fréquentes
            </h3>
            <div class="accordion">
              <div
                v-for="(item, index) in faq"
                :key="index"
                ref="faqItems"
                class="accordion-item border-0 border-bottom faq-animate"
                :style="{ transitionDelay: `${index * 100}ms` }"
              >
                <button
                  class="accordion-button bg-transparent shadow-none py-3 px-0 d-flex justify-content-between w-100 text-start"
                  type="button"
                  @click="toggleFaq(index)"
                >
                  <span>{{ item.question }}</span>
                  <font-awesome-icon
                    icon="chevron-down"
                    class="ms-2 flex-shrink-0 icon-rotate"
                    :class="{ 'icon-rotated': openIndex === index }"
                  />
                </button>
                <div
                  v-if="openIndex === index"
                  class="accordion-body px-0 pb-3"
                  v-html="item.answer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SponsorshipHowItWorks',
  data() {
    return {
      openIndex: null,
      clientCount: 173,
      steps: [
        {
          title: 'Partager votre code',
          icon: 'mail-send',
          description: 'Entrez son adresse email',
          color: 'pink-300',
        },
        {
          title: 'Il reçoit votre invitation',
          icon: 'mail-receive',
          description: 'Un email avec un lien personnel',
          color: 'blue-300',
        },
        {
          title: 'Vous gagnez 10 € chacun',
          icon: 'bills10',
          description: 'Après sa souscription',
          color: 'green-300',
        },
      ],
      faq: [
        {
          question: 'Qui peut bénéficier du programme de parrainage ?',
          answer: `Le programme de parrainage est ouvert à tous les clients Assurup disposant d'un compte actif.
            Vous pouvez inviter des entrepreneurs ou des entreprises qui <span>ne sont pas encore clients chez Assurup.</span>
            Une fois l'invitation envoyée, votre contact recevra un email avec un lien personnel pour découvrir Assurup et souscrire une assurance.`,
        },
        {
          question: 'Quelle est la récompense du parrainage ?',
          answer: `Lorsque votre filleul souscrit une assurance chez Assurup, <span>🎁 vous recevez chacun 10 €</span> :
            <ul class="mt-2">
              <li><span>10 €</span> pour vous (crédité dans votre cagnotte)</li>
              <li><span>10 €</span> de réduction pour votre filleul sur son assurance</li>
            </ul>`,
        },
        {
          question: 'Quand vais-je recevoir ma récompense ?',
          answer: `La récompense est créditée dans votre cagnotte <span>une fois que votre filleul a souscrit et activé son contrat d'assurance chez Assurup.</span>
            Vous pourrez ensuite utiliser votre cagnotte pour <span>réduire le montant de votre prochaine cotisation.</span>`,
        },
        {
          question: 'Combien d\'entrepreneurs puis-je inviter ?',
          answer: `Vous pouvez inviter <span>jusqu'à 10 entrepreneurs par jour et 50 par mois.</span>
            Chaque invitation est envoyée par email avec un lien personnel permettant à votre contact de découvrir Assurup et de souscrire une assurance.
            Chaque parrainage validé vous permet de gagner <span>10 €,</span> avec des bonus supplémentaires selon le nombre de filleuls.`,
        },
        {
          question: 'Que se passe-t-il si mon filleul ne souscrit pas ?',
          answer: `Si votre filleul ne finalise pas sa souscription chez Assurup, le parrainage ne sera pas validé.
            Dans ce cas, <span>aucune récompense ne sera attribuée.</span>
            Vous pouvez toutefois inviter d'autres entrepreneurs à tout moment depuis votre espace client.`,
        },
        {
          question: 'Comment utiliser ma cagnotte ?',
          answer: `Les récompenses obtenues grâce au parrainage sont créditées dans votre cagnotte Assurup.
            Cette cagnotte est <span>déduite de votre prochaine cotisation d'assurance dès lors que vous avez cliqué sur "Utiliser ma cagnotte".</span>
            La cagnotte n'est pas convertible en argent et ne peut être utilisée que pour régler des services Assurup.`,
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('faq-visible');
            }
          });
        },
        { threshold: 0.1 }
      );
      this.$refs.faqItems?.forEach((item) => observer.observe(item));
    });
  },
  methods: {
    toggleFaq(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
.accordion-button::after {
  display: none;
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

.accordion-button {
  color: var(--bs-blue-700);
}

.accordion-button:not(.collapsed) {
  color: var(--bs-blue-700);
}


.faq-animate {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.faq-visible {
  opacity: 1;
  transform: translateY(0);
}

/* Icon rotation animation */
.icon-rotate {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.icon-rotated {
  transform: rotate(180deg);
}

.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-card-1-1 {
  left: 20px;
  width: 39px;
  top: 35%;
  background-color: var(--bs-yellow-300);
}
.pill-card-1-2 {
  left: 30px;
  width: 64px;
  bottom: 10%;
  background-color: var(--bs-green-300);
}
.pill-card-1-3 {
  bottom: 14%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-2-1 {
  top: 37%;
  right: 20px;
  width: 48px;
  background-color: var(--bs-blue-300);
}
.pill-card-2-2 {
  left: 30px;
  width: 50px;
  height: 10px;
  bottom: 20%;
  background-color: var(--bs-green-300);
}
.pill-card-2-3 {
  bottom: 10%;
  width: 33px;
  right: 30px;
  background-color: var(--bs-pink-300);
}

.pill-card-3-1 {
  top: 30%;
  width: 39px;
  height: 8px;
  right: 30px;
  background-color: var(--bs-yellow-300);
}
.pill-card-3-2 {
  bottom: 17%;
  width: 30px;
  right: 30px;
  background-color: var(--bs-green-300);
}
.pill-card-3-3 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-blue-300);
}
</style>

<style>
.accordion-body span {
  font-weight: 600;
}
</style>
